var React = require( 'react' );
var ReactDOM = require( 'react-dom' );
var Provider = require( 'react-redux' ).Provider;
var router = require('react-router');

var Router = router.Router;
var Route = router.Route;
var IndexRoute = router.IndexRoute;
var IndexRedirect = router.IndexRedirect;
var browserHistory = router.browserHistory;

var actions = require('./actions');
var store = require( './store' );
var MainContainer = require('./main-container').Container;
var CasinoDetails = require('./casino-details').Container;
var TournamentInfo = require('./tournament-info').Container;
var HubPage = require('./pages/hub-page');
var GuideDailyTournaments = require('./pages/guide-daily-tournaments');
var Glossary = require('./pages/glossary');
var GuideFaq = require('./pages/guide-faq');
var GuideStakeUs = require('./pages/guide-stake-us');
var HomePage = require('./pages/home-page');
var About = require('./pages/about');
var AllRooms = require('./pages/all-rooms');

var STAKE_GO_URL = '/go/stake?utm_source=dailytourneys&utm_medium=banner&utm_campaign=stake';

var StakeBanner = function() {
    return (
        <aside className="stake-ad" aria-label="Stake offer">
          <a
            className="stake-banner"
            href={STAKE_GO_URL}
            target="_blank"
            rel="noopener noreferrer sponsored"
          >
            <img
              className="stake-banner-art"
              src="/images/stake-us-banner.png?v=28"
              alt=""
            />
            <p className="stake-offer">Claim $25 Stake Cash + 250k Gold Coins</p>
          </a>
          <p className="stake-banner-disclosure">21+ · Play responsibly · Terms on Stake.us</p>
        </aside>
    );
};

var App = function(props) {
    return (
        <div className="app-shell">
            <StakeBanner />

            <header className="app-header">
              <div className="header-band">
                <div className="brand-row">
                  <span className="brand-mark" aria-hidden="true"></span>
                  <span className="brand-name">Daily Tourneys</span>
                </div>
                {(!props.location || props.location.pathname === '/')
                  ? <h1>Find U.S. casino and poker room tournament schedules</h1>
                  : <p className="header-title">Find U.S. casino and poker room tournament schedules</p>}
                <p className="tagline">Search daily and weekly poker tournaments at U.S. casinos — rooms, buy-ins, and what’s running.</p>
              </div>
            </header>

            <main className="panel">
                {props.children}
            </main>
        </div>
    );
};

var routes = (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      {/* Real homepage: search + intro + footer (no redirect) */}
      <IndexRoute component={HomePage} />
      {/* Static content routes MUST come before :casinos or they are swallowed */}
      <Route path="about" component={About} />
      <Route path="all-poker-rooms" component={AllRooms} />
      <Route path="guides/how-daily-tournaments-work" component={GuideDailyTournaments} />
      <Route path="guides/tournament-terms" component={Glossary} />
      <Route path="guides/poker-tournament-faq" component={GuideFaq} />
      <Route path="guides/how-stake-us-works" component={GuideStakeUs} />
      {HubPage.dedicatedPaths.map(function(hubPath) {
        return <Route key={hubPath} path={hubPath} component={HubPage} />;
      })}
      <Route path="hubs/:slug" component={HubPage} />
      <Route path=":casinos">
        <IndexRedirect to="/" />
          <Route path=":name">
            <IndexRoute component={CasinoDetails}/>
              <Route path=":tournaments">
                <IndexRoute component={TournamentInfo}/>
              </Route>
          </Route>
      </Route>
    </Route>
  </Router>
);

document.addEventListener('DOMContentLoaded', function() {
  store.dispatch(actions.newSearch());

    ReactDOM.render(
      <Provider store={store}>
        {routes}
      </Provider>, document.getElementById('app'));
});



// WEBPACK FOOTER //
// ./js/index.jsx